webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(127);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Navbar = __webpack_require__(46);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _router = __webpack_require__(69);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _fontawesomeSvgCore = __webpack_require__(33);
	
	var _freeSolidSvgIcons = __webpack_require__(48);
	
	var _freeBrandsSvgIcons = __webpack_require__(47);
	
	var _vueFontawesome = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.Vue = _vue2.default;
	
	
	_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.faFacebookF);
	_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.faTwitter);
	_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.faVimeo);
	_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.faBehance);
	_fontawesomeSvgCore.library.add(_freeBrandsSvgIcons.faInstagram);
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faAngleLeft);
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faAngleRight);
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faBars);
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faTimes);
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faExternalLinkSquareAlt);
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faHome);
	_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCaretSquareLeft);
	
	_vue2.default.component('font-awesome-icon', _vueFontawesome.FontAwesomeIcon);
	
	var version = '1.0.2';
	console.log('version', version);
	
	new _vue2.default({
	  router: _router2.default,
	  components: {
	    'navbar': _Navbar2.default
	  },
	  render: function render(h) {
	    return h(_App2.default);
	  }
	}).$mount('#app');

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

	module.exports = {
		"nav": {
			"home": "HOME",
			"about": "ABOUT",
			"food": "FOOD",
			"projects": "PROJECTS+EVENTS",
			"takeaway": "HOME EDITION",
			"whatwedo": "WHAT WE DO",
			"gallery": "GALLERY",
			"contact": "CONTACT",
			"logo": "logo.png"
		},
		"home": {
			"title": "CREATIVE<br/>FOOD<br/>INDULGENCE",
			"subtitle": "A LONDON-BASED CATERING AND DESIGN COLLECTIVE <br class='break-large' />PRODUCING BESPOKE FOOD, EXPERIENCES AND CONTENT FOR A WIDE <br class='break-large' />SPECTRUM OF CLIENTS LOOKING FOR SOMETHING DIFFERENT",
			"lockup": {
				"lockup_1": "home_lockup_portrait_01.jpg",
				"lockup_2": "home_lockup_landscape_01.jpg",
				"lockup_3": "home_lockup_square_01.jpg",
				"text_img": "masthead_text.png"
			},
			"about": "ABOUT",
			"about_body": [
				"Room Service launched with the ‘Club Sandwich Luxe’ pop-up and Shoreditch kitchen residency in 2015. Although the food and offering has evolved, the <i>indulgent, shameless excess</i> those towering club sandwiches represent set the template that runs through everything we do."
			],
			"food": "FOOD",
			"food_body": [
				"Championing food that is social and seasonal, with a laidback indulgence."
			],
			"food_image": "food_home_landscape_01.jpg",
			"projects": "PROJECTS<br/>+<br/>EVENTS",
			"projects_body": [
				"Creative projects, unique events, curation and consultancy with food always at the heart."
			],
			"projects_image": "projects_home_landscape_01.jpg",
			"canteen": "QUARANTINE CANTEEN",
			"canteen_body": [
				"Some canteen copy to go in here."
			],
			"canteen_image": "food_home_landscape_01.jpg",
			"contact_button": "GET IN TOUCH",
			"link_button": "READ MORE",
			"loadArray": [
				"home/home_lockup_portrait_01.jpg",
				"home/home_lockup_landscape_01.jpg",
				"home/home_lockup_square_01.jpg",
				"home/masthead_text.png",
				"home/food_home_landscape_01.jpg",
				"home/projects_home_landscape_01.jpg"
			]
		},
		"contact": {
			"contact_button": "GET IN TOUCH",
			"instagram_icon_dark": "instagram_logo.svg",
			"instagram_icon_light": "instagram_logo_pink.svg",
			"instagram_link": "https://www.instagram.com/getroomservice/",
			"instagram_text": "@getroomservice ",
			"email_icon_dark": "email_logo.svg",
			"email_icon_light": "email_logo_pink.svg",
			"email_link": "mailto:hello@getroomservice.co?subject=Hello",
			"email_text": "hello@getroomservice.co",
			"phone_icon_dark": "phone_logo.svg",
			"phone_icon_light": "phone_logo_pink.svg",
			"phone_link": "tel:07980915489",
			"phone_text": "07980 915489",
			"pink_instagram_icon": "instagram_logo_pink.svg",
			"pink_email_icon": "email_logo_pink.svg"
		},
		"food": {
			"title": "FOOD",
			"subtitle": "CHAMPIONING FOOD THAT IS SOCIAL AND SEASONAL, WITH A LAIDBACK INDULGENCE, WE GET KICKS FROM CONTEMPORARY FINE DINING TO FAST FOOD, STREET FOOD TO BRITISH CLASSICS, THE GOOD LIFE TO THE DOWNRIGHT DIRTY",
			"body": [
				"Sourcing the best possible ingredients from quality, unique suppliers so we can consciously deliver shameless excess and indulgence on plates, sticks, bowls, boxes and platters.",
				"A custom approach to every feast, party or project. This means no generic menus to have to choose from, no 'one size fits all' attitude. We'll come back with ideas to fit any brief and budget, and are happy to inspire clients who don't yet have a starting point.",
				"Street food for 500 in a field, banquets for 150 in a warehouse, feasts for 50 on a private island or canapés to add proper flavour to a launch event. Whatever the event and whatever the size, we make food to make your party."
			],
			"folder": "food",
			"lockup": {
				"lockup_1": "food_lockup_portrait_01.jpg",
				"lockup_2": "food_lockup_landscape_01.jpg",
				"lockup_3": "food_lockup_square_01.jpg",
				"text_img": "masthead_text_food.png"
			},
			"loadArray": [
				"food/food_lockup_portrait_01.jpg",
				"food/food_lockup_landscape_01.jpg",
				"food/food_lockup_square_01.jpg",
				"food/masthead_text_food.png"
			]
		},
		"projects": {
			"title": "PROJECTS<br/>+<br/>EVENTS",
			"subtitle": "Creative projects, unique events, curation <br class='break-large' />and consultancy with food always at the heart",
			"body": [
				"As well as chefs, we have a network of designers, art directors, food stylists and event producers. This means we deliver way more than just food on a plate and takes the stress out of our client's hands.",
				"We've brought underground 80s New York to Osea Island, transformed a North London Hotel into the 1970s Riviera Beach Club, as well as creating beautifully styled spaces across a wide range of unique venues we have access to. ",
				"Menu and packaging design, branding, art direction and food styling for content or events. Our approach aims to add layers of flavour for all the senses. ",
				"<i>We also run our own events, creative projects and supper clubs. Keep your eyes peeled via <a href='https://www.instagram.com/getroomservice/' target='_blank'>Instagram</a></i>"
			],
			"folder": "projects",
			"lockup": {
				"lockup_1": "projects_lockup_portrait_01.jpg",
				"lockup_2": "projects_lockup_landscape_01.jpg",
				"lockup_3": "projects_lockup_square_01.jpg",
				"text_img": "masthead_text_projects.png"
			},
			"loadArray": [
				"projects/projects_lockup_portrait_01.jpg",
				"projects/projects_lockup_landscape_01.jpg",
				"projects/projects_lockup_square_01.jpg",
				"projects/masthead_text_projects.png"
			]
		},
		"takeaway": {
			"title": "HOME EDITION",
			"subtitle": "REFINED GOOD TIMES FOOD TO FEAST AT HOME.<br/><br/>HOT TAKEAWAYS AND D.I.Y. <br class='break-small' />FOOD KITS<br/><br/>REGULARLY CHANGING MENUS. DELIVERY OR COLLECTION.",
			"body_tdw": [
				"There are no romantic getaways this year so let us bring the dirty weekend to you. <br/><br/>Expect luxury hotel classics with a loved up flavour. <strong>Heads, Hearts & Tails</strong> have you fully covered on the drinks front, plus complete the love-fix with flowers from <strong>Floral Cacophony</strong>."
			],
			"body": [
				"We’ve lockdown-proofed ourselves for 2021, bringing our slice of food indulgence to<br/>your dining tables, sofas and beds. <br class='break-small' />Proper Room Service.",
				"<span class='body-title'>WHAT WE OFFER:</span><br/><br/>- Regularly changing menus of ready to go feasts for delivery or collection.<br/><br/>- DIY meal kits and food boxes to prep at home.<br/><br/>- Bespoke requests. Try us!",
				"<span class='body-title'>COLLECTION & DELIVERY:</span><br/><br/>We are now delivering London-wide. Please get in touch if you need more info.<br/><br/>If you are collecting, please be sure to select a time slot at check out.<br/><br/>Collection is from our kitchen unit in the heart of Barnes:<br/><br/><strong>Unit 1, The Mews, 46-52 Church Rd, SW13 0DQ</strong><br/>(just on Bracken Gardens above the mechanics)."
			],
			"menu_button": "THIS WEEK’S MENU",
			"menu_link": "http://getroomservice.co/menus/20210116_menu.pdf",
			"second_menu_button": "NYE VEGGIE MENU",
			"second_menu_link": "http://getroomservice.co/menus/20201231_veggie.pdf",
			"order_button_old": "ORDER NOW",
			"order_button": "MENUS & ORDERING",
			"shopify_link": "https://getroomservice.myshopify.com/",
			"order_email": "hello@getroomservice.co",
			"folder": "food",
			"lockup": {
				"lockup_1": "lockup_portrait_01.jpg",
				"lockup_2": "lockup_landscape_01.jpg",
				"lockup_3": "logo.png",
				"text_img": "masthead_text2_takeaway.png"
			},
			"old": [
				"<span class='body-title'>HOW TO ORDER</span>",
				"",
				"Email <a href='mailto:hello@getroomservice.co'>hello@getroomservice.co</a> by <strong>Midday on Thursday</strong>.<br/><br/>In your email state: order quantities, side orders (don’t forget to specify quantities of each side portion), collection/delivery time and day, name, address and contact telephone number.<br/><br/>We will reply with confirmations and payment details.<br/><br/>If you have any allergies or dietary preferences, please let us know.",
				"*"
			]
		},
		"loadArray": [
			"home/home_lockup_portrait_01.jpg",
			"home/home_lockup_landscape_01.jpg",
			"home/home_lockup_square_01.jpg",
			"home/masthead_text.png",
			"home/food_home_landscape_01.jpg",
			"home/projects_home_landscape_01.jpg",
			"food/food_lockup_portrait_01.jpg",
			"food/food_lockup_landscape_01.jpg",
			"food/food_lockup_square_01.jpg",
			"food/masthead_text_food.png",
			"projects/projects_lockup_portrait_01.jpg",
			"projects/projects_lockup_landscape_01.jpg",
			"projects/projects_lockup_square_01.jpg",
			"projects/masthead_text_projects.png"
		],
		"about": {
			"title": "ABOUT",
			"subtitle": "A LONDON-BASED CATERING AND DESIGN COLLECTIVE <br class='break-large' />PRODUCING BESPOKE FOOD, EXPERIENCES AND CONTENT FOR A WIDE <br class='break-large' />SPECTRUM OF CLIENTS LOOKING FOR SOMETHING DIFFERENT",
			"body": [
				"Room Service launched with the ‘Club Sandwich Luxe’ pop-up and Shoreditch kitchen residency in 2015. Although the food and offering has evolved, the indulgent, shameless excess those towering club sandwiches represent set the template that runs through everything we do.",
				"Massively inspired by the diverse food scene in our native city (London) we get kicks from across the board; contemporary fine dining to fast food, global street food to British classics, the good life to the downright dirty. We champion food that is social and seasonal, with a laidback indulgence. In essence, we make food to make your party.",
				"Working with a stellar group of private clients, brands and companies, we have created everything from intimate dining experiences on private islands and festival food for 500 in fields, to social content and small bites for brand experiences.",
				"Every job, whatever the size, is treated with the same custom indulgence, care and excitement. Our team and network have backgrounds in private catering, restaurants, bars, street food, event production, styling, design and marketing. This means we can deliver way more than just food on a plate."
			]
		},
		"takeaway_popup": {
			"active": false,
			"hasAppeared": false,
			"showMe": false,
			"showon": [
				"takeaway"
			],
			"title": "",
			"body": [
				"WE ARE HAVING A COUPLE OF WEEKS OFF <br/>OVER CHRISTMAS.",
				"THANK YOU TO EVERYONE WHO’S ORDERED <br/>OVER THE LAST FEW WEEKS. WE’VE REALLY <br/>APPRECIATED THE SUPPORT.",
				"WE ARE FLIRTING WITH THE IDEA OF DOING A SPECIAL NEW YEAR’S EVE MENU. KEEP YOUR EYES PEELED FOR MORE INFO.",
				"FOLLOW US ON INSTAGRAM FOR ALL THE <br/>LATEST NEWS AND UPDATES: <a href='https://www.instagram.com/getroomservice/' target='_blank'>@GETROOMSERVICE</a>",
				"MERRY CHRISTMAS!"
			],
			"popup_button_active": false,
			"popup_button": "READ MORE",
			"popup_route": "takeaway",
			"popup_image_logo": "/takeaway/logo.png",
			"popup_image_title": "/takeaway/masthead_text2_takeaway.png",
			"popup_image_main_desktop": "/takeaway/lockup_portrait_01.jpg",
			"popup_image_main_mobile": "/takeaway/lockup_landscape_01.jpg"
		},
		"popup": {
			"active": false,
			"hasAppeared": false,
			"showMe": false,
			"showon": [
				"homeedition"
			],
			"title": "",
			"body": [
				"We’ve lockdown-proofed ourselves for 2021, bringing our slice of food indulgence to<br/>your dining tables, sofas and beds. Proper Room Service."
			],
			"popup_button": "READ MORE",
			"popup_route": "homeedition",
			"popup_image_logo": "/takeaway/logo.png",
			"popup_image_title": "/takeaway/masthead_text2_takeaway.png",
			"popup_image_main_desktop": "/takeaway/lockup_portrait_01.jpg",
			"popup_image_main_mobile": "/takeaway/lockup_landscape_01.jpg"
		},
		"slideshow": {
			"home_array": [
				{
					"title": "Spotify<br/>Wimborne House",
					"img1": "spotify2_landscape_01.jpg",
					"img2": "spotify2_portrait_01.jpg",
					"img3": "spotify2_square_01.jpg",
					"t": 1
				},
				{
					"title": "Chassay & Co<br/>Shoreditch Treehouse",
					"img1": "chassay_landscape_02.jpg",
					"img2": "chassay_landscape_01.jpg",
					"img3": "chassay_portrait_01.jpg",
					"t": 4
				},
				{
					"title": "Spotify<br/>Vinyl Factory",
					"img1": "spotify1_landscape_03.jpg",
					"img2": "spotify1_landscape_02.jpg",
					"img3": "spotify1_landscape_01.jpg",
					"t": 2
				},
				{
					"title": "Buzzfeed<br/>33 Fitzroy Square",
					"img1": "buzzfeed_landscape_01.jpg",
					"img2": "buzzfeed_landscape_02.jpg",
					"img3": "buzzfeed_landscape_03.jpg",
					"t": 3
				},
				{
					"title": "Proper<br/>Social Campaign",
					"img1": "proper_portrait_01.jpg",
					"img2": "proper_portrait_02.gif",
					"img3": "proper_square_01.jpg",
					"t": 6
				},
				{
					"title": "Curzon Cinemas",
					"img1": "curzon_square_01.jpg",
					"img2": "curzon_landscape_02.jpg",
					"img3": "curzon_portrait_01.jpg",
					"t": 5
				},
				{
					"title": "Club Sandwich Luxe",
					"img1": "sandwich_landscape_01.jpg",
					"img2": "sandwich_portrait_01.jpg",
					"img3": "sandwich_square_01.jpg",
					"t": 1
				},
				{
					"title": "Open Table<br/>Kings Cross",
					"img1": "opentable_landscape_02.jpg",
					"img2": "opentable_landscape_01.jpg",
					"img3": "opentable_landscape_03.jpg",
					"t": 2
				}
			],
			"food_array": [
				{
					"title": "",
					"img1": "food_carousel_01_01.jpg",
					"img2": "food_carousel_01_02.jpg",
					"img3": "food_carousel_01_03.jpg",
					"t": 7
				},
				{
					"title": "",
					"img1": "food_carousel_02_01.jpg",
					"img2": "food_carousel_02_02.jpg",
					"img3": "food_carousel_02_03.jpg",
					"t": 8
				},
				{
					"title": "",
					"img1": "food_carousel_03_02.jpg",
					"img2": "food_carousel_03_01.jpg",
					"img3": "food_carousel_03_03.jpg",
					"t": 9
				},
				{
					"title": "",
					"img1": "food_carousel_04_01.jpg",
					"img2": "food_carousel_04_02.jpg",
					"img3": "food_carousel_04_03.jpg",
					"t": 10
				},
				{
					"title": "",
					"img1": "food_carousel_05_01.jpg",
					"img2": "food_carousel_05_03.jpg",
					"img3": "food_carousel_05_02.jpg",
					"t": 11
				}
			],
			"projects_array": [
				{
					"title": "",
					"img1": "projects_carousel_01_01.jpg",
					"img2": "projects_carousel_01_02.jpg",
					"img3": "projects_carousel_01_03.jpg",
					"t": 12
				},
				{
					"title": "",
					"img1": "projects_carousel_02_01.jpg",
					"img2": "projects_carousel_02_02.jpg",
					"img3": "projects_carousel_02_03.jpg",
					"t": 13
				},
				{
					"title": "",
					"img1": "projects_carousel_03_01.jpg",
					"img2": "projects_carousel_03_02.jpg",
					"img3": "projects_carousel_03_03.jpg",
					"t": 14
				},
				{
					"title": "",
					"img1": "projects_carousel_04_01.jpg",
					"img2": "projects_carousel_04_03.jpg",
					"img3": "projects_carousel_04_02.jpg",
					"t": 15
				},
				{
					"title": "",
					"img1": "projects_carousel_05_01.jpg",
					"img2": "projects_carousel_05_03.jpg",
					"img3": "projects_carousel_05_02.jpg",
					"t": 16
				}
			]
		},
		"ticker": {
			"home": [
				{
					"entry": "Dinners & Banquets"
				},
				{
					"entry": "Canapés"
				},
				{
					"entry": "Food Boxes"
				},
				{
					"entry": "BBQ’s"
				},
				{
					"entry": "Small Plates"
				},
				{
					"entry": "Street Food"
				},
				{
					"entry": "Fast Food"
				},
				{
					"entry": "Crew & Shoot Catering"
				},
				{
					"entry": "Hampers"
				},
				{
					"entry": "Artist Riders"
				},
				{
					"entry": "Corporate Lunches"
				},
				{
					"entry": "Private Chef Service"
				},
				{
					"entry": "Themed Food & Feasts"
				},
				{
					"entry": "Brand Experiences"
				},
				{
					"entry": "Supper Clubs"
				},
				{
					"entry": "Menu Design & Consultancy"
				},
				{
					"entry": "Event Production"
				},
				{
					"entry": "Food Styling"
				},
				{
					"entry": "Brand Content"
				},
				{
					"entry": "Event Bars"
				},
				{
					"entry": "Creative Direction"
				},
				{
					"entry": "Event Styling"
				},
				{
					"entry": "‘White Label’ Event Food"
				}
			],
			"food": [
				{
					"entry": "Dinners & Banquets"
				},
				{
					"entry": "Canapés"
				},
				{
					"entry": "Food Boxes"
				},
				{
					"entry": "BBQ’s"
				},
				{
					"entry": "Small Plates"
				},
				{
					"entry": "Street Food"
				},
				{
					"entry": "Fast Food"
				},
				{
					"entry": "Crew & Shoot Catering"
				},
				{
					"entry": "Hampers"
				},
				{
					"entry": "Artist Riders"
				},
				{
					"entry": "Corporate Lunches"
				},
				{
					"entry": "Private Chef Service"
				},
				{
					"entry": "Themed Food & Feasts"
				}
			],
			"projects": [
				{
					"entry": "Brand Experiences"
				},
				{
					"entry": "Supper Clubs"
				},
				{
					"entry": "Menu Design & Consultancy"
				},
				{
					"entry": "Event Production"
				},
				{
					"entry": "Food Styling"
				},
				{
					"entry": "Brand Content"
				},
				{
					"entry": "Event Bars"
				},
				{
					"entry": "Creative Direction"
				},
				{
					"entry": "Event Styling"
				},
				{
					"entry": "‘White Label’ Event Food"
				}
			]
		},
		"clients": {
			"title": "WHO WE'VE WORKED WITH",
			"array": [
				{
					"logo": "nike.svg"
				},
				{
					"logo": "curzon.svg"
				},
				{
					"logo": "sonos.svg"
				},
				{
					"logo": "warner.svg"
				},
				{
					"logo": "converse.svg"
				},
				{
					"logo": "airbnb.svg"
				},
				{
					"logo": "buzzfeed.svg"
				},
				{
					"logo": "coach.svg"
				},
				{
					"logo": "nbcuniversal.svg"
				},
				{
					"logo": "spotify.svg"
				},
				{
					"logo": "mcsaatchi.svg"
				},
				{
					"logo": "veuveclicquot.svg"
				},
				{
					"logo": "amplify.svg"
				},
				{
					"logo": "opentable.svg"
				},
				{
					"logo": "ovalspace.svg"
				},
				{
					"logo": "proper.svg"
				},
				{
					"logo": "chivas.svg"
				},
				{
					"logo": "goodstuff.svg"
				}
			]
		},
		"footer": {
			"array": [
				{
					"img": "footer_01.jpg"
				},
				{
					"img": "footer_02.jpg"
				},
				{
					"img": "footer_03.jpg"
				},
				{
					"img": "footer_04.jpg"
				},
				{
					"img": "footer_05.jpg"
				}
			]
		}
	};

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.commontools = undefined;
	
	var _promise = __webpack_require__(70);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commontools = exports.commontools = {
	  methods: {
	    getMeta: function getMeta(_meta) {
	      var meta = _meta;
	
	      if (meta === undefined) {
	        return [{ name: 'title', content: '404', id: 'titl' }];
	      } else {
	        return [{ name: 'title', content: meta.meta_title, id: 'titl' }, { name: 'description', content: meta.meta_desc, id: 'desc' }, { property: 'og:title', content: meta.og_title, id: 'ogtitle' }, { property: 'og:description', content: meta.og_desc, id: 'ogdesc' }, { property: 'og:image', content: meta.og_image, id: 'ogimage' }, { property: 'og:url', content: meta.og_url, id: 'ogurl' }, { property: 'twitter:card', content: meta.twitter_card, id: 'twcard' }, { property: 'twitter:site', content: meta.twitter_site, id: 'twsite' }, { property: 'twitter:title', content: meta.twitter_title, id: 'twtitle' }, { property: 'twitter:description', content: meta.twitter_desc, id: 'twdesc' }, { property: 'twitter:image', content: meta.twitter_image, id: 'twimage' }];
	      }
	    },
	    manageWidows: function manageWidows() {
	      this.arrangeWidows('p');
	      this.arrangeWidows('h3');
	    },
	
	    preloadImages: function preloadImages(url) {
	      return new _promise2.default(function (resolve) {
	        var image = new Image();
	        image.addEventListener('load', function () {
	          resolve(image);
	        });
	        image.src = url;
	      });
	    },
	    arrangeWidows: function arrangeWidows(_type) {
	      var p = document.getElementsByTagName(_type);
	
	      var _loop = function _loop(i) {
	        var text = p[i].innerHTML;
	        var splits = text.split(' ');
	
	        var newText = '';
	
	        splits.map(function (s, index) {
	          if (index < splits.length - 2) newText += s + ' ';
	        });
	
	        var lastWord = splits[splits.length - 1];
	        var secondlast = splits[splits.length - 2];
	        p[i].innerHTML = newText + '<span class="nobr">' + secondlast + ' ' + lastWord + '</span>';
	      };
	
	      for (var i = 0; i < p.length; i++) {
	        _loop(i);
	      }
	    }
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(119)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(56),
	  /* template */
	  __webpack_require__(152),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(113)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(52),
	  /* template */
	  __webpack_require__(146),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-6005547a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(109)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(54),
	  /* template */
	  __webpack_require__(142),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(104)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(62),
	  /* template */
	  __webpack_require__(137),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(110)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(57),
	  /* template */
	  __webpack_require__(143),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(108)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(55),
	  /* template */
	  __webpack_require__(141),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-3325cfa0",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(107)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(58),
	  /* template */
	  __webpack_require__(140),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(118)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(51),
	  /* template */
	  __webpack_require__(151),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(122)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(59),
	  /* template */
	  __webpack_require__(155),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Footbar = __webpack_require__(128);
	
	var _Footbar2 = _interopRequireDefault(_Footbar);
	
	var _PopupOverlay = __webpack_require__(129);
	
	var _PopupOverlay2 = _interopRequireDefault(_PopupOverlay);
	
	var _TakeawayPopup = __webpack_require__(130);
	
	var _TakeawayPopup2 = _interopRequireDefault(_TakeawayPopup);
	
	var _Navbar = __webpack_require__(46);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _content = __webpack_require__(2);
	
	var _Styling = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  mixins: [_Styling.commontools],
	  data: function data() {
	    return {
	      popup: _content.popup,
	      takeaway_popup: _content.takeaway_popup,
	      showPopup: false,
	      loadArray: _content.loadArray,
	      isActive: true,
	      isReady: false,
	      loadCounter: 0
	    };
	  },
	  watch: {
	    $route: function $route(to, from) {
	      this.checkTakeawayPopup();
	    }
	  },
	  methods: {
	    loadImages: function loadImages() {
	      var _this = this;
	
	      this.loadArray.map(function (url) {
	        _this.preloadImages('static/img/content/' + url).then(function (myimg) {
	          _this.loadCounter--;
	          if (_this.loadCounter === 0) {
	            _this.isReady = true;
	            _this.checkPopup();
	            _this.checkTakeawayPopup();
	          }
	        });
	      });
	    },
	    checkPopup: function checkPopup() {
	      var _this2 = this;
	
	      if (this.popup.active && !this.popup.hasAppeared) {
	        this.popup.hasAppeared = true;
	        if (this.$route.name != this.popup.popup_route) {
	          setTimeout(function () {
	            _this2.popup.showMe = true;
	          }, 2000);
	        }
	      }
	    },
	    checkTakeawayPopup: function checkTakeawayPopup() {
	      var _this3 = this;
	
	      console.log(this.takeaway_popup.active, this.takeaway_popup.hasAppeared);
	      if (this.takeaway_popup.active && !this.takeaway_popup.hasAppeared) {
	        if (this.$route.name == this.takeaway_popup.popup_route) {
	          this.takeaway_popup.hasAppeared = true;
	          setTimeout(function () {
	            _this3.takeaway_popup.showMe = true;
	          }, 2000);
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    if (!('ontouchstart' in document.documentElement)) {
	      document.documentElement.className += ' no-touch-device';
	    }
	    this.popup = _content.popup;
	    this.takeaway_popup = _content.takeaway_popup;
	    this.loadCounter = this.loadArray.length;
	    this.loadImages();
	  },
	  components: { footbar: _Footbar2.default, navbar: _Navbar2.default, popupoverlay: _PopupOverlay2.default, takeawaypopup: _TakeawayPopup2.default }
	};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	exports.default = {
	  data: function data() {
	    return {
	      clients: _content.clients,
	      displayclients: []
	    };
	  },
	  methods: {
	    getClients: function getClients() {
	      this.displayclients = this.getRandomClients(this.clients.array, 18);
	    },
	    getRandomClients: function getRandomClients(arr, n) {
	      var result = new Array(n);
	      var len = arr.length;
	      var taken = new Array(len);
	
	      if (n > len) throw new RangeError('getRandom: more elements taken than available');
	      while (n--) {
	        var x = Math.floor(Math.random() * len);
	        if (n === 11) {
	          x = 0;
	        }
	        result[n] = arr[x in taken ? taken[x] : x];
	        taken[x] = --len in taken ? taken[len] : len;
	      }
	      return result;
	    }
	  },
	  created: function created() {},
	  destroyed: function destroyed() {},
	
	  mounted: function mounted() {
	    this.getClients();
	  },
	  components: {}
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      contact: _content.contact
	    };
	  },
	  methods: {},
	  created: function created() {},
	  destroyed: function destroyed() {},
	
	  mounted: function mounted() {},
	  components: {
	    LinkButton: _LinkButton2.default
	  }
	};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	exports.default = {
	  name: 'footbar',
	  data: function data() {
	    return {
	      contact: _content.contact
	    };
	  }
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	var _ImageLoader = __webpack_require__(23);
	
	var _ImageLoader2 = _interopRequireDefault(_ImageLoader);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueLazyload = __webpack_require__(22);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueLazyload2.default, {
	  observer: true,
	  throttleWait: 3000,
	
	  observerOptions: {
	    rootMargin: '0px',
	    threshold: 0.1
	  },
	  lazyComponent: true
	});
	
	exports.default = {
	  name: 'footerimage',
	  data: function data() {
	    return {
	      footer: _content.footer,
	      path: null
	    };
	  },
	
	  methods: {},
	  mounted: function mounted() {
	    this.path = window.innerWidth < 576 ? 'footer/mobile/' : 'footer/';
	  },
	  components: {
	    ImageLoader: _ImageLoader2.default
	  }
	};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['imgSrc'],
	  data: function data() {
	    return {
	      imgLoaded: false,
	      imgOpacity: 0
	    };
	  },
	  methods: {
	    handler: function handler() {},
	    thisLoaded: function thisLoaded() {
	      var _this = this;
	
	      this.$nextTick(function () {
	        _this.imgLoaded = true;
	        _this.imgOpacity = 1;
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.imgOpacity = 0;
	  }
	};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['label'],
	  data: function data() {
	    return {
	      paddingTop: 0
	    };
	  },
	  methods: {
	    goToLink: function goToLink() {}
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	var _ImageLoader = __webpack_require__(23);
	
	var _ImageLoader2 = _interopRequireDefault(_ImageLoader);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueLazyload = __webpack_require__(22);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueLazyload2.default, {
	  observer: true,
	  throttleWait: 3000,
	
	  observerOptions: {
	    rootMargin: '0px',
	    threshold: 0.1
	  },
	  lazyComponent: true
	});
	exports.default = {
	  props: ['page'],
	  data: function data() {
	    return {
	      home: _content.home,
	      food: _content.food,
	      takeaway: _content.takeaway,
	      projects: _content.projects,
	      paddingTop: 0,
	      mastheight: 0
	    };
	  },
	  methods: {
	    padMast: function padMast() {
	      var ch = this.$el.clientHeight;
	      this.paddingTop = ch / 2;
	    }
	  },
	  created: function created() {
	    window.addEventListener('scroll', this.scrollMast);
	  },
	  destroyed: function destroyed() {
	    window.removeEventListener('scroll', this.scrollMast);
	  },
	
	  mounted: function mounted() {
	    this.mastheight = '100%';
	    this.padMast();
	  },
	  computed: {},
	  components: {
	    ImageLoader: _ImageLoader2.default
	  }
	};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	var _ImageLoader = __webpack_require__(23);
	
	var _ImageLoader2 = _interopRequireDefault(_ImageLoader);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueLazyload = __webpack_require__(22);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueLazyload2.default, {
	  observer: true,
	  throttleWait: 3000,
	
	  observerOptions: {
	    rootMargin: '0px',
	    threshold: 0.1
	  },
	  lazyComponent: true
	});
	
	exports.default = {
	  props: ['array'],
	  data: function data() {
	    return {
	      slideshow: _content.slideshow,
	      myCaseStudies: [],
	      imageCount: 0,
	      clickindex: 0,
	      mywidth: 0,
	      imgwidth: 0,
	      leftPos: 0,
	      showLeft: true,
	      showRight: true,
	      startx: 0,
	      imgcounter: 0,
	      imgheight: 0,
	      imgopacity: 0,
	      gap: 105,
	      blockRight: false,
	      blockLeft: false
	    };
	  },
	  methods: {
	    checkLoaded: function checkLoaded() {
	      var _this = this;
	
	      this.imgcounter++;
	      if (this.imgcounter === this.imgs.length) {
	        this.$nextTick(function () {
	          _this.imgheight = 'auto';
	          setTimeout(function () {
	            _this.imgopacity = 1;
	          }, 50);
	        });
	      }
	    },
	    clickArrow: function clickArrow(_val) {
	      var _this2 = this;
	
	      if (this.blockLeft || this.blockRight) return;
	      var val = _val;
	      this.$nextTick(function () {
	        if (val === -1) {
	          _this2.blockRight = true;
	          _this2.myCaseStudies.map(function (c, i) {
	            c['position'] += val;
	            if (c['position'] < -2) c['position'] = _this2.myCaseStudies.length - 3;
	          });
	        }
	        if (val === 1) {
	          _this2.blockLeft = true;
	          _this2.myCaseStudies.map(function (c, i) {
	            c['position'] += val;
	            if (c['position'] > _this2.myCaseStudies.length - 3) c['position'] = -2;
	          });
	        }
	        setTimeout(function () {
	          _this2.blockRight = false;
	          _this2.blockLeft = false;
	        }, 400);
	      });
	    },
	
	    clickSlider: function clickSlider(i) {},
	    showButtons: function showButtons(i) {
	      this.showLeft = this.clickindex > 0;
	      this.showRight = this.clickindex < this.imgs.length - 1;
	    },
	    setWidths: function setWidths() {
	      this.mywidth = this.imgs.length * this.gap;
	      this.imgwidth = this.gap / this.imgs.length;
	    },
	    startSwipe: function startSwipe(evt) {
	      this.startx = evt.changedTouches[0].clientX;
	    },
	    moveSwipe: function moveSwipe(evt) {},
	    endSwipe: function endSwipe(evt) {
	      var endx = evt.changedTouches[0].clientX;
	      if (this.startx > endx + 75) this.clickArrow(-1);
	      if (this.startx < endx - 75) this.clickArrow(1);
	    },
	    handler: function handler() {
	      this.myCaseStudies = this.slideshow[this.array];
	      this.myCaseStudies.map(function (c, i) {
	        _vue2.default.set(c, 'position', i - 2);
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.handler();
	  },
	  computed: {},
	  components: {
	    ImageLoader: _ImageLoader2.default
	  }
	};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Styling = __webpack_require__(5);
	
	var _content = __webpack_require__(2);
	
	var Vue = __webpack_require__(7);
	var VueScrollTo = __webpack_require__(158);
	Vue.use(VueScrollTo, {
	  container: 'body',
	  duration: 800,
	  easing: 'ease',
	  offset: -120,
	  force: true,
	  cancelable: true,
	  onStart: false,
	  onDone: false,
	  onCancel: false,
	  x: false,
	  y: true
	});
	
	exports.default = {
	  name: 'navbar',
	  mixins: [_Styling.commontools],
	  data: function data() {
	    return {
	      pagetype: 0,
	      hideMainMenu: false,
	      panelOpen: false,
	      pagename: '',
	      nav: _content.nav,
	      showDropdown: false,
	      yTop: false,
	      logoY: 0,
	      hideArrow: false
	    };
	  },
	
	  watch: {
	    $route: function $route(to, from) {
	      this.getNavParams();
	    }
	  },
	  methods: {
	    getNavParams: function getNavParams() {
	      if (this.pagename !== this.$route.name) this.panelOpen = false;
	      this.pagename = this.$route.name;
	    },
	    clickBurger: function clickBurger() {
	      this.panelOpen = !this.panelOpen;
	    },
	    clickNavPanel: function clickNavPanel() {
	      this.panelOpen = false;
	    },
	    clickClose: function clickClose() {
	      this.showMobileMenu = false;
	      this.getNavParams();
	    },
	    handleNavScroll: function handleNavScroll() {
	      this.percent = window.scrollY;
	      this.hideArrow = this.percent >= 5;
	      if (this.percent >= this.logoY) {
	        this.hideMainMenu = true;
	      } else {
	        this.hideMainMenu = false;
	      }
	    },
	    handleResize: function handleResize() {
	      this.logoY = window.innerHeight / 2;
	    }
	  },
	  created: function created() {
	    window.addEventListener('scroll', this.handleNavScroll);
	    window.addEventListener('resize', this.handleResize);
	  },
	  destroyed: function destroyed() {
	    window.removeEventListener('scroll', this.handleNavScroll);
	    window.removeEventListener('resize', this.handleResize);
	  },
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.getNavParams();
	    this.$nextTick(function () {
	      _this.handleResize();
	    }, 10);
	  },
	  updated: function updated() {}
	};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Styling = __webpack_require__(5);
	
	var _content = __webpack_require__(2);
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'popup',
	  mixins: [_Styling.commontools],
	  data: function data() {
	    return {
	      popup: _content.popup
	    };
	  },
	
	  methods: {
	    closePopup: function closePopup() {
	      this.popup.showMe = false;
	    },
	    clickLink: function clickLink() {
	      this.popup.showMe = false;
	      this.$router.push(_content.popup.popup_route);
	    }
	  },
	  mounted: function mounted() {},
	  updated: function updated() {},
	  components: {
	    LinkButton: _LinkButton2.default
	  }
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Styling = __webpack_require__(5);
	
	var _content = __webpack_require__(2);
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'takeaway_popup',
	  mixins: [_Styling.commontools],
	  data: function data() {
	    return {
	      takeaway_popup: _content.takeaway_popup
	    };
	  },
	
	  methods: {
	    closePopup: function closePopup() {
	      this.takeaway_popup.showMe = false;
	    },
	    clickLink: function clickLink() {
	      this.takeaway_popup.showMe = false;
	      this.$router.push(_content.takeaway_popup.popup_route);
	    }
	  },
	  mounted: function mounted() {},
	  updated: function updated() {},
	  components: {
	    LinkButton: _LinkButton2.default
	  }
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	exports.default = {
	  props: ['page'],
	  data: function data() {
	    return {
	      paddingTop: 0,
	      ticker: _content.ticker,
	      tickerType: '',
	      tickerContent: '',
	      time: 0
	    };
	  },
	  methods: {
	    getTickerData: function getTickerData() {
	      var _this = this;
	
	      this.ticker[this.tickerType].map(function (e) {
	        _this.time += 2;
	        _this.tickerContent += e.entry + ' | ';
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.tickerType = this.page;
	    this.getTickerData();
	  }
	};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _FooterImage = __webpack_require__(11);
	
	var _FooterImage2 = _interopRequireDefault(_FooterImage);
	
	var _ContactSection = __webpack_require__(10);
	
	var _ContactSection2 = _interopRequireDefault(_ContactSection);
	
	var _TextTicker = __webpack_require__(12);
	
	var _TextTicker2 = _interopRequireDefault(_TextTicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'fourzerofour',
	  data: function data() {
	    return {
	      mastheight: 0
	    };
	  },
	  mounted: function mounted() {
	    this.mastheight = window.innerHeight * 0.5;
	    window.scrollTo(0, 0);
	  },
	  components: {
	    LinkButton: _LinkButton2.default,
	    FooterImage: _FooterImage2.default,
	    ContactSection: _ContactSection2.default,
	    TextTicker: _TextTicker2.default
	  }
	};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	var _MastHead = __webpack_require__(16);
	
	var _MastHead2 = _interopRequireDefault(_MastHead);
	
	var _Styling = __webpack_require__(5);
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _FooterImage = __webpack_require__(11);
	
	var _FooterImage2 = _interopRequireDefault(_FooterImage);
	
	var _TextTicker = __webpack_require__(12);
	
	var _TextTicker2 = _interopRequireDefault(_TextTicker);
	
	var _ContactSection = __webpack_require__(10);
	
	var _ContactSection2 = _interopRequireDefault(_ContactSection);
	
	var _ClientSection = __webpack_require__(32);
	
	var _ClientSection2 = _interopRequireDefault(_ClientSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_Styling.commontools],
	  name: 'about',
	  watch: {
	    '$route.name': function $routeName(id) {
	      window.scrollTo(0, 0);
	    }
	  },
	  data: function data() {
	    return {
	      about: _content.about,
	      clients: _content.clients
	    };
	  },
	
	  methods: {},
	  created: function created() {},
	  mounted: function mounted() {
	    window.scrollTo(0, 0);
	  },
	  components: {
	    MastHead: _MastHead2.default,
	    LinkButton: _LinkButton2.default,
	    FooterImage: _FooterImage2.default,
	    TextTicker: _TextTicker2.default,
	    ContactSection: _ContactSection2.default,
	    ClientSection: _ClientSection2.default
	  }
	};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	var _MastHead = __webpack_require__(16);
	
	var _MastHead2 = _interopRequireDefault(_MastHead);
	
	var _Styling = __webpack_require__(5);
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _FooterImage = __webpack_require__(11);
	
	var _FooterImage2 = _interopRequireDefault(_FooterImage);
	
	var _TextTicker = __webpack_require__(12);
	
	var _TextTicker2 = _interopRequireDefault(_TextTicker);
	
	var _ContactSection = __webpack_require__(10);
	
	var _ContactSection2 = _interopRequireDefault(_ContactSection);
	
	var _MyCarousel = __webpack_require__(24);
	
	var _MyCarousel2 = _interopRequireDefault(_MyCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_Styling.commontools],
	  name: 'food',
	  watch: {
	    '$route.name': function $routeName(id) {
	      window.scrollTo(0, 0);
	    }
	  },
	  data: function data() {
	    return {
	      food: _content.food,
	      metatitle: '',
	      loadCounter: 0
	    };
	  },
	
	  methods: {},
	  created: function created() {},
	  mounted: function mounted() {
	    window.scrollTo(0, 0);
	  },
	  components: {
	    MastHead: _MastHead2.default,
	    LinkButton: _LinkButton2.default,
	    FooterImage: _FooterImage2.default,
	    TextTicker: _TextTicker2.default,
	    ContactSection: _ContactSection2.default,
	    MyCarousel: _MyCarousel2.default
	  }
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	var _Styling = __webpack_require__(5);
	
	var _MastHead = __webpack_require__(16);
	
	var _MastHead2 = _interopRequireDefault(_MastHead);
	
	var _MyCarousel = __webpack_require__(24);
	
	var _MyCarousel2 = _interopRequireDefault(_MyCarousel);
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _TextTicker = __webpack_require__(12);
	
	var _TextTicker2 = _interopRequireDefault(_TextTicker);
	
	var _FooterImage = __webpack_require__(11);
	
	var _FooterImage2 = _interopRequireDefault(_FooterImage);
	
	var _ContactSection = __webpack_require__(10);
	
	var _ContactSection2 = _interopRequireDefault(_ContactSection);
	
	var _ClientSection = __webpack_require__(32);
	
	var _ClientSection2 = _interopRequireDefault(_ClientSection);
	
	var _ImageLoader = __webpack_require__(23);
	
	var _ImageLoader2 = _interopRequireDefault(_ImageLoader);
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueLazyload = __webpack_require__(22);
	
	var _vueLazyload2 = _interopRequireDefault(_vueLazyload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueLazyload2.default, {
	  observer: true,
	  throttleWait: 3000,
	
	  observerOptions: {
	    rootMargin: '0px',
	    threshold: 0.1
	  },
	  lazyComponent: true
	});
	
	exports.default = {
	  name: 'home',
	  mixins: [_Styling.commontools],
	  data: function data() {
	    return {
	      home: _content.home,
	      scrolly: 0,
	      mymobile: '',
	      myimage: '',
	      loadCounter: 0
	    };
	  },
	  methods: {
	    scrollToDiv: function scrollToDiv(_div) {
	      var top = document.getElementById(_div).offsetTop;
	      window.scrollTo(0, top - 43);
	    }
	  },
	  created: function created() {
	    window.scrollTo(0, 0);
	  },
	  destroyed: function destroyed() {},
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.mastheight = window.innerHeight;
	    window.scrollTo(0, 0);
	    setTimeout(function () {
	      if (_this.$route.name !== 'home') return;
	      if (_this.$route.params.scroll !== undefined) _this.scrollToDiv(_this.$route.params.scroll);
	    }, 100);
	  },
	  components: {
	    MastHead: _MastHead2.default,
	    ImageLoader: _ImageLoader2.default,
	    MyCarousel: _MyCarousel2.default,
	    FooterImage: _FooterImage2.default,
	    LinkButton: _LinkButton2.default,
	    ContactSection: _ContactSection2.default,
	    ClientSection: _ClientSection2.default,
	    TextTicker: _TextTicker2.default
	  }
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _content = __webpack_require__(2);
	
	var _MastHead = __webpack_require__(16);
	
	var _MastHead2 = _interopRequireDefault(_MastHead);
	
	var _Styling = __webpack_require__(5);
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _FooterImage = __webpack_require__(11);
	
	var _FooterImage2 = _interopRequireDefault(_FooterImage);
	
	var _TextTicker = __webpack_require__(12);
	
	var _TextTicker2 = _interopRequireDefault(_TextTicker);
	
	var _ContactSection = __webpack_require__(10);
	
	var _ContactSection2 = _interopRequireDefault(_ContactSection);
	
	var _MyCarousel = __webpack_require__(24);
	
	var _MyCarousel2 = _interopRequireDefault(_MyCarousel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_Styling.commontools],
	  name: 'projects',
	  watch: {
	    '$route.name': function $routeName(id) {
	      window.scrollTo(0, 0);
	    }
	  },
	  data: function data() {
	    return {
	      projects: _content.projects
	    };
	  },
	
	  methods: {},
	  created: function created() {},
	  mounted: function mounted() {
	    window.scrollTo(0, 0);
	  },
	  components: {
	    MastHead: _MastHead2.default,
	    LinkButton: _LinkButton2.default,
	    FooterImage: _FooterImage2.default,
	    TextTicker: _TextTicker2.default,
	    ContactSection: _ContactSection2.default,
	    MyCarousel: _MyCarousel2.default
	  }
	};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MastHead = __webpack_require__(16);
	
	var _MastHead2 = _interopRequireDefault(_MastHead);
	
	var _Styling = __webpack_require__(5);
	
	var _LinkButton = __webpack_require__(6);
	
	var _LinkButton2 = _interopRequireDefault(_LinkButton);
	
	var _FooterImage = __webpack_require__(11);
	
	var _FooterImage2 = _interopRequireDefault(_FooterImage);
	
	var _TextTicker = __webpack_require__(12);
	
	var _TextTicker2 = _interopRequireDefault(_TextTicker);
	
	var _ContactSection = __webpack_require__(10);
	
	var _ContactSection2 = _interopRequireDefault(_ContactSection);
	
	var _MyCarousel = __webpack_require__(24);
	
	var _MyCarousel2 = _interopRequireDefault(_MyCarousel);
	
	var _ClientSection = __webpack_require__(32);
	
	var _ClientSection2 = _interopRequireDefault(_ClientSection);
	
	var _content = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_Styling.commontools],
	  name: 'takeaway',
	  watch: {
	    '$route.name': function $routeName(id) {
	      window.scrollTo(0, 0);
	    }
	  },
	  data: function data() {
	    return {
	      takeaway: _content.takeaway,
	      metatitle: '',
	      loadCounter: 0
	    };
	  },
	
	  methods: {},
	  created: function created() {},
	  mounted: function mounted() {
	    window.scrollTo(0, 0);
	  },
	  components: {
	    MastHead: _MastHead2.default,
	    LinkButton: _LinkButton2.default,
	    FooterImage: _FooterImage2.default,
	    TextTicker: _TextTicker2.default,
	    ContactSection: _ContactSection2.default,
	    ClientSection: _ClientSection2.default,
	    MyCarousel: _MyCarousel2.default
	  }
	};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(157);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueHead = __webpack_require__(126);
	
	var _vueHead2 = _interopRequireDefault(_vueHead);
	
	var _vueResource = __webpack_require__(156);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _Home = __webpack_require__(134);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Food = __webpack_require__(133);
	
	var _Food2 = _interopRequireDefault(_Food);
	
	var _Takeaway = __webpack_require__(136);
	
	var _Takeaway2 = _interopRequireDefault(_Takeaway);
	
	var _Projects = __webpack_require__(135);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _About = __webpack_require__(132);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _ = __webpack_require__(131);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	_vue2.default.use(_vueHead2.default);
	
	_vue2.default.use(_vueResource2.default);
	
	var routes = [{ name: 'home', path: '/', component: _Home2.default }, { name: 'food', path: '/food', component: _Food2.default }, { name: 'projects', path: '/projects', component: _Projects2.default }, { name: 'about', path: '/about', component: _About2.default }, { name: '404', path: '*', component: _2.default }];
	exports.default = new _vueRouter2.default({
	  scrollBehavior: function scrollBehavior() {
	    return { x: 0, y: 0 };
	  },
	
	  mode: 'history',
	  base: '',
	  routes: routes,
	  linkActiveClass: 'is-active'
	});

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(115)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(50),
	  /* template */
	  __webpack_require__(148),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(111)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(53),
	  /* template */
	  __webpack_require__(144),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(117)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(60),
	  /* template */
	  __webpack_require__(150),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(120)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(61),
	  /* template */
	  __webpack_require__(153),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(116)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(63),
	  /* template */
	  __webpack_require__(149),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(114)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(64),
	  /* template */
	  __webpack_require__(147),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(106)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(65),
	  /* template */
	  __webpack_require__(139),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-2a314e00",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(121)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(66),
	  /* template */
	  __webpack_require__(154),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(105)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(67),
	  /* template */
	  __webpack_require__(138),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(112)
	}
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(68),
	  /* template */
	  __webpack_require__(145),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-548edfd2",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "ticker-band"
	  }, [_c('div', {
	    staticClass: "ticker-inner",
	    style: ({
	      '-webkit-animation': 'marquee ' + _vm.time + 's linear infinite',
	      'animation': 'marquee ' + _vm.time + 's linear infinite'
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.tickerContent)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "ticker-inner-2",
	    style: ({
	      '-webkit-animation': 'marqueetwo ' + _vm.time + 's linear infinite',
	      'animation': 'marqueetwo ' + _vm.time + 's linear infinite'
	    }),
	    domProps: {
	      "innerHTML": _vm._s(_vm.tickerContent)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-container"
	  }, [_c('section', {
	    staticClass: "mobile"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "masthead-logo-mobile mobile"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/common/logo.png'
	    }
	  })])])])])]), _vm._v(" "), _c('mast-head', {
	    ref: "mst",
	    attrs: {
	      "page": "projects"
	    }
	  }), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row intro-box"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center"
	  }, [_c('h3', {
	    staticClass: "h3-subtitle",
	    domProps: {
	      "innerHTML": _vm._s(_vm.projects.subtitle)
	    }
	  })])])])]), _vm._v(" "), _c('section', [_c('my-carousel', {
	    attrs: {
	      "array": 'projects_array'
	    }
	  })], 1), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center"
	  }, _vm._l((_vm.projects.body), function(p, index) {
	    return _c('p', {
	      staticClass: "page-paragraph",
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }))])])]), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-bottom"
	  }, [_c('text-ticker', {
	    attrs: {
	      "page": "projects"
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-top"
	  }, [_c('footer-image')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-container"
	  }, [_c('section', {
	    staticClass: "mobile"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "masthead-logo-mobile mobile"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/common/logo.png'
	    }
	  })])])])])]), _vm._v(" "), _c('mast-head', {
	    ref: "mst",
	    attrs: {
	      "page": "food"
	    }
	  }), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row intro-box"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center"
	  }, [_c('h3', {
	    staticClass: "h3-subtitle",
	    domProps: {
	      "innerHTML": _vm._s(_vm.food.subtitle)
	    }
	  })])])])]), _vm._v(" "), _c('section', [_c('my-carousel', {
	    attrs: {
	      "array": 'food_array'
	    }
	  })], 1), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center"
	  }, _vm._l((_vm.food.body), function(p, index) {
	    return _c('p', {
	      staticClass: "page-paragraph",
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }))])])]), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-bottom"
	  }, [_c('text-ticker', {
	    attrs: {
	      "page": "food"
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-top"
	  }, [_c('footer-image')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    ref: "slider",
	    staticClass: "col-xs-12 col-sm-12 col-lg-10 col-lg-offset-1 carousel"
	  }, [_c('div', {
	    staticClass: "carousel-inner",
	    on: {
	      "touchstart": _vm.startSwipe,
	      "touchmove": _vm.moveSwipe,
	      "touchend": _vm.endSwipe
	    }
	  }, _vm._l((_vm.myCaseStudies), function(item, index) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (item.position >= -2 && item.position < 3),
	        expression: "item.position >= -2 && item.position < 3"
	      }],
	      key: index,
	      staticClass: "carousel-container",
	      class: {
	        'carousel-quick': item.position >= 2 && _vm.blockRight || item.position <= -2 && _vm.blockLeft
	      },
	      style: ({
	        '-webkit-transition-delay': 'webkit-transform ' + (item.position * 0.05) + 's',
	        'webkit-transform': 'translateX(' + item.position * _vm.gap + '%)'
	      })
	    }, [_c('div', {
	      staticClass: "carousel-template",
	      class: 'carousel-template-' + item.t
	    }, [_c('div', {
	      staticClass: "carousel-img carousel-img1"
	    }, [_c('image-loader', {
	      staticClass: "image-loader-container",
	      attrs: {
	        "imgSrc": 'carousel/' + item.img1
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "carousel-img-overlay",
	      class: {
	        'active': item.position !== 0
	      }
	    })], 1), _vm._v(" "), (item.img2) ? _c('div', {
	      staticClass: "carousel-img carousel-img2"
	    }, [_c('image-loader', {
	      staticClass: "image-loader-container",
	      attrs: {
	        "imgSrc": 'carousel/' + item.img2
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "carousel-img-overlay",
	      class: {
	        'active': item.position !== 0
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (item.img3) ? _c('div', {
	      staticClass: "carousel-img carousel-img3"
	    }, [_c('image-loader', {
	      staticClass: "image-loader-container",
	      attrs: {
	        "imgSrc": 'carousel/' + item.img3
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "carousel-img-overlay",
	      class: {
	        'active': item.position !== 0
	      }
	    })], 1) : _vm._e(), _vm._v(" "), _c('label', {
	      class: {
	        'active': item.position == 0
	      },
	      domProps: {
	        "innerHTML": _vm._s(item.title)
	      }
	    })])])
	  })), _vm._v(" "), _c('div', {
	    staticClass: "arrow-button arrow-left",
	    on: {
	      "click": function($event) {
	        _vm.clickArrow(1)
	      }
	    }
	  }, [_c('img', {
	    staticClass: "arrow-button-svg arrow-button-svg-dark",
	    attrs: {
	      "src": 'static/img/common/left_dark.svg'
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "arrow-button-svg arrow-button-svg-light",
	    attrs: {
	      "src": 'static/img/common/left_light.svg'
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "arrow-button arrow-right",
	    on: {
	      "click": function($event) {
	        _vm.clickArrow(-1)
	      }
	    }
	  }, [_c('img', {
	    staticClass: "arrow-button-svg arrow-button-svg-dark",
	    attrs: {
	      "src": 'static/img/common/left_dark.svg'
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "arrow-button-svg arrow-button-svg-light",
	    attrs: {
	      "src": 'static/img/common/left_light.svg'
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "imageloader-background",
	    class: {
	      'active': !_vm.imgLoaded
	    }
	  }), _vm._v(" "), _c('img', {
	    ref: "myImg",
	    staticClass: "imageloader-image",
	    style: ({
	      'opacity': _vm.imgOpacity + '!important'
	    }),
	    attrs: {
	      "src": 'static/img/content/' + _vm.imgSrc
	    },
	    on: {
	      "load": function($event) {
	        _vm.thisLoaded()
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "gallery-container"
	    }
	  }, [_c('lazy-component', [_c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "gallery"
	    }
	  }, [_c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "gallery-mobile"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-offset-2 col-sm-offset-1 col-sm-10 col-md-8"
	  }, _vm._l((_vm.footer.array), function(item, index) {
	    return _c('image-loader', {
	      staticClass: "image-loader-container",
	      attrs: {
	        "imgSrc": _vm.path + item.img
	      }
	    })
	  }))])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "fullscreen-element no-pad centered-text",
	    attrs: {
	      "id": "top"
	    }
	  }, [(_vm.page == 'home') ? _c('div', {
	    staticClass: "container masthead-container masthead-container-home"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left"
	  }, [_c('div', {
	    staticClass: "masthead-inner",
	    attrs: {
	      "id": "home-masthead"
	    }
	  }, [_c('div', {
	    staticClass: "masthead-logo desktop"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/common/logo.png'
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-1"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'home/' + _vm.home.lockup.lockup_1
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-2"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'home/' + _vm.home.lockup.lockup_2
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-3"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'home/' + _vm.home.lockup.lockup_3
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-text"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'home/' + _vm.home.lockup.text_img
	    }
	  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.page == 'food') ? _c('div', {
	    staticClass: "container masthead-container masthead-container-food"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left"
	  }, [_c('div', {
	    staticClass: "masthead-inner"
	  }, [_c('div', {
	    staticClass: "masthead-image masthead-image-1"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'food/' + _vm.food.lockup.lockup_1
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-2"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'food/' + _vm.food.lockup.lockup_2
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-3"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'food/' + _vm.food.lockup.lockup_3
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-text"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'food/' + _vm.food.lockup.text_img
	    }
	  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.page == 'takeaway') ? _c('div', {
	    staticClass: "container masthead-container masthead-container-takeaway"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left"
	  }, [_c('div', {
	    staticClass: "masthead-inner"
	  }, [_c('div', {
	    staticClass: "masthead-image masthead-image-1"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'takeaway/' + _vm.takeaway.lockup.lockup_1
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-2"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'takeaway/' + _vm.takeaway.lockup.lockup_2
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-3"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'takeaway/' + _vm.takeaway.lockup.lockup_3
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-text"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'takeaway/' + _vm.takeaway.lockup.text_img
	    }
	  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.page == 'projects') ? _c('div', {
	    staticClass: "container masthead-container masthead-container-projects"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left"
	  }, [_c('div', {
	    staticClass: "masthead-inner"
	  }, [_c('div', {
	    staticClass: "masthead-image masthead-image-1"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'projects/' + _vm.projects.lockup.lockup_1
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-2"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'projects/' + _vm.projects.lockup.lockup_2
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-image-3"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'projects/' + _vm.projects.lockup.lockup_3
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "masthead-image masthead-text"
	  }, [_c('image-loader', {
	    staticClass: "masthead-desktop",
	    attrs: {
	      "imgSrc": 'projects/' + _vm.projects.lockup.text_img
	    }
	  })], 1)])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    attrs: {
	      "id": "footer"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-5 footer-social-icons"
	  }, [_c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": _vm.contact.email_link,
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "social-icon",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.email_icon_light,
	      "type": "image/svg+xml"
	    }
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.contact.instagram_link,
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "social-icon social-icon-insta",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.instagram_icon_light,
	      "type": "image/svg+xml"
	    }
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": _vm.contact.phone_link,
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "social-icon",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.phone_icon_light,
	      "type": "image/svg+xml"
	    }
	  })])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-xs-7"
	  }, [_c('img', {
	    staticClass: "footer-logo",
	    attrs: {
	      "src": "static/img/common/logo.svg",
	      "type": "image/svg+xml"
	    }
	  }), _vm._v(" "), _c('label', [_c('strong', [_vm._v("CREATIVE FOOD INDULGENCE")]), _c('br'), _vm._v("©Room Service 2021")])])
	}]}

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-container"
	  }, [_c('section', {
	    staticClass: "mobile"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "masthead-logo-mobile mobile"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/common/logo.png'
	    }
	  })])])])])]), _vm._v(" "), _c('mast-head', {
	    ref: "mst",
	    attrs: {
	      "page": "takeaway"
	    }
	  }), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row intro-box"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center"
	  }, [_c('h3', {
	    staticClass: "h3-subtitle",
	    domProps: {
	      "innerHTML": _vm._s(_vm.takeaway.subtitle)
	    }
	  })])])])]), _vm._v(" "), _c('section', {
	    staticClass: "section-no-pad-top"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center"
	  }, [_vm._l((_vm.takeaway.body), function(p, index) {
	    return _c('p', {
	      staticClass: "page-paragraph",
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), _c('a', {
	    staticClass: "router-link-container",
	    attrs: {
	      "href": _vm.takeaway.shopify_link,
	      "target": "_blank"
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.takeaway.order_button
	    }
	  })], 1)], 2)])])]), _vm._v(" "), _c('section', {
	    staticClass: "pure-text-centered",
	    attrs: {
	      "id": "clients"
	    }
	  }, [_c('client-section')], 1), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-bottom"
	  }, [_c('text-ticker', {
	    attrs: {
	      "page": "food"
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-top"
	  }, [_c('footer-image')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "contact-section"
	    }
	  }, [_c('div', {
	    staticClass: "row text-center desktop"
	  }, [_c('h2', {
	    staticClass: "heading-light"
	  }, [_vm._v("GET IN TOUCH")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.contact.instagram_link
	    }
	  }, [_c('span', {
	    staticClass: "contact-social-icon"
	  }, [_c('img', {
	    staticClass: "social-icon-svg",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.instagram_icon_dark,
	      "type": "image/svg+xml"
	    }
	  })]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.contact.instagram_text)
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.contact.email_link
	    }
	  }, [_c('span', {
	    staticClass: "contact-social-icon"
	  }, [_c('img', {
	    staticClass: "social-icon-svg",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.email_icon_dark,
	      "type": "image/svg+xml"
	    }
	  })]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.contact.email_text)
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": _vm.contact.phone_link
	    }
	  }, [_c('span', {
	    staticClass: "contact-social-icon"
	  }, [_c('img', {
	    staticClass: "social-icon-svg",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.phone_icon_dark,
	      "type": "image/svg+xml"
	    }
	  })]), _vm._v(" "), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.contact.phone_text)
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "row text-center mobile"
	  }, [_c('h2', {
	    staticClass: "heading-light"
	  }, [_vm._v("GET IN TOUCH")]), _vm._v(" "), _c('div', {
	    staticClass: "contact-social-icon"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.contact.email_link
	    }
	  }, [_c('img', {
	    staticClass: "social-icon-svg social-icon-svg-dark",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.email_icon_dark,
	      "type": "image/svg+xml"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "social-icon-svg social-icon-svg-light",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.email_icon_light,
	      "type": "image/svg+xml"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "contact-social-icon contact-social-icon-insta"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.contact.instagram_link,
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "social-icon-svg social-icon-svg-dark",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.instagram_icon_dark,
	      "type": "image/svg+xml"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "social-icon-svg social-icon-svg-light",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.instagram_icon_light,
	      "type": "image/svg+xml"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "contact-social-icon contact-social-icon-insta"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.contact.phone_link,
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    staticClass: "social-icon-svg social-icon-svg-dark",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.phone_icon_dark,
	      "type": "image/svg+xml"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "social-icon-svg social-icon-svg-light",
	    attrs: {
	      "src": 'static/img/common/' + _vm.contact.phone_icon_light,
	      "type": "image/svg+xml"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 147 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-container"
	  }, [_c('section', {
	    staticClass: "mobile"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "masthead-logo-mobile mobile"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/common/logo.png'
	    }
	  })])])])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "about-section"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "col-md-10 col-md-offset-1 text-center"
	  }, [_c('h1', {
	    staticClass: "h1-title",
	    domProps: {
	      "innerHTML": _vm._s(_vm.about.title)
	    }
	  }), _vm._v(" "), _c('h3', {
	    staticClass: "h3-subtitle h3-subtitle-padded",
	    domProps: {
	      "innerHTML": _vm._s(_vm.about.subtitle)
	    }
	  }), _vm._v(" "), _vm._l((_vm.about.body), function(p, index) {
	    return _c('p', {
	      staticClass: "page-paragraph",
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  })], 2)])])]), _vm._v(" "), _c('section', {
	    staticClass: "pure-text-centered",
	    attrs: {
	      "id": "clients"
	    }
	  }, [_c('client-section')], 1), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-bottom"
	  }, [_c('text-ticker', {
	    attrs: {
	      "page": "home"
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-top"
	  }, [_c('footer-image')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "loader",
	    class: {
	      active: !_vm.isReady
	    }
	  }), _vm._v(" "), _c('div', {
	    class: {
	      active: _vm.isReady
	    },
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('navbar'), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [_c('router-view', {
	    class: {
	      active: _vm.isActive
	    },
	    attrs: {
	      "id": "my-router-view"
	    }
	  })], 1), _vm._v(" "), _c('footbar'), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.popup.showMe) ? _c('popupoverlay') : _vm._e(), _vm._v(" "), (_vm.takeaway_popup.showMe) ? _c('takeawaypopup') : _vm._e()], 1), _vm._v(" "), _vm._m(0)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "rotate-warning"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "rotate-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "rotate-sprite"
	    }
	  }), _vm._v(" "), _c('h3', [_vm._v("Please rotate your device")])])])
	}]}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-container"
	  }, [_c('header', {
	    staticClass: "fullscreen-element no-pad centered-text",
	    attrs: {
	      "id": "header-404"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 text-center"
	  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('p', {
	    staticClass: "lead"
	  }, [_vm._v("\n              Page not found."), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": 'HOME'
	    }
	  })], 1)], 1)])])])]), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-bottom"
	  }, [_c('text-ticker', {
	    attrs: {
	      "page": "home"
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-top"
	  }, [_c('footer-image')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay"
	  }, [_c('div', {
	    staticClass: "popup-container container-fluid desktop"
	  }, [_c('div', {
	    staticClass: "popup-close",
	    class: {
	      'active': true
	    },
	    on: {
	      "click": _vm.closePopup
	    }
	  }, [_c('div', {
	    staticClass: "burger-bar close-bar-2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "burger-bar close-bar-1"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row  popup-copy-container "
	  }, [_c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('img', {
	    staticClass: "popup-logo-image",
	    attrs: {
	      "src": 'static/img/content' + _vm.popup.popup_image_logo
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "popup-title-image",
	    attrs: {
	      "src": 'static/img/content' + _vm.popup.popup_image_title
	    }
	  }), _vm._v(" "), _vm._l((_vm.popup.body), function(p, index) {
	    return _c('p', {
	      staticClass: "page-paragraph",
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": _vm.popup.popup_link
	    },
	    on: {
	      "click": _vm.clickLink
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.popup.popup_button
	    }
	  })], 1)], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/content' + _vm.popup.popup_image_main_desktop
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "popup-container container mobile"
	  }, [_c('div', {
	    staticClass: "popup-close",
	    class: {
	      'active': true
	    },
	    on: {
	      "click": _vm.closePopup
	    }
	  }, [_c('div', {
	    staticClass: "burger-bar close-bar-2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "burger-bar close-bar-1"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row "
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [_c('img', {
	    staticClass: "popup-logo-image",
	    attrs: {
	      "src": 'static/img/content' + _vm.popup.popup_image_logo
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "popup-title-image",
	    attrs: {
	      "src": 'static/img/content' + _vm.popup.popup_image_title
	    }
	  }), _vm._v(" "), _vm._l((_vm.popup.body), function(p, index) {
	    return _c('p', {
	      staticClass: "page-paragraph",
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": _vm.popup.popup_link
	    },
	    on: {
	      "click": _vm.clickLink
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.popup.popup_button
	    },
	    on: {
	      "click": _vm.closePopup
	    }
	  })], 1)], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-12 text-center popup-main-image-mobile"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/content' + _vm.popup.popup_image_main_mobile
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "clients"
	    }
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('h2', {
	    staticClass: "heading-light",
	    domProps: {
	      "innerHTML": _vm._s(_vm.clients.title)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.displayclients), function(client, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "col-lg-2 col-md-2 col-sm-2 col-xs-4 client-object"
	    }, [_c('object', {
	      staticClass: "cls-1",
	      attrs: {
	        "data": 'static/img/content/logos/' + client.logo,
	        "type": "image/svg+xml"
	      }
	    })])
	  }))])])])
	},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "link-button"
	  }, [_c('div', {
	    staticClass: "link-button-bottom"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "link-button-top",
	    domProps: {
	      "innerHTML": _vm._s(_vm.label)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "overlay"
	  }, [_c('div', {
	    staticClass: "popup-container container-fluid desktop"
	  }, [_c('div', {
	    staticClass: "popup-close",
	    class: {
	      'active': true
	    },
	    on: {
	      "click": _vm.closePopup
	    }
	  }, [_c('div', {
	    staticClass: "burger-bar close-bar-2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "burger-bar close-bar-1"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row  popup-copy-container "
	  }, [_c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('img', {
	    staticClass: "popup-logo-image",
	    attrs: {
	      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_logo
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "popup-title-image",
	    attrs: {
	      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_title
	    }
	  }), _vm._v(" "), _vm._l((_vm.takeaway_popup.body), function(p, index) {
	    return _c('p', {
	      staticClass: "page-paragraph page-paragraph-small",
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), (_vm.takeaway_popup.popup_button_active) ? _c('div', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": _vm.takeaway_popup.popup_link
	    },
	    on: {
	      "click": _vm.clickLink
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.takeaway_popup.popup_button
	    }
	  })], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 text-center"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_main_desktop
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "popup-container container mobile"
	  }, [_c('div', {
	    staticClass: "popup-close",
	    class: {
	      'active': true
	    },
	    on: {
	      "click": _vm.closePopup
	    }
	  }, [_c('div', {
	    staticClass: "burger-bar close-bar-2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "burger-bar close-bar-1"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "row "
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [_c('img', {
	    staticClass: "popup-logo-image",
	    attrs: {
	      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_logo
	    }
	  }), _vm._v(" "), _c('img', {
	    staticClass: "popup-title-image",
	    attrs: {
	      "src": 'static/img/content' + _vm.takeaway_popup.popup_image_title
	    }
	  }), _vm._v(" "), _vm._l((_vm.takeaway_popup.body), function(p, index) {
	    return _c('p', {
	      staticClass: "page-paragraph page-paragraph-small",
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), (_vm.takeaway_popup.popup_button_active) ? _c('div', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": _vm.takeaway_popup.popup_link
	    },
	    on: {
	      "click": _vm.clickLink
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.takeaway_popup.popup_button
	    },
	    on: {
	      "click": _vm.closePopup
	    }
	  })], 1) : _vm._e()], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-container"
	  }, [_c('section', {
	    staticClass: "mobile"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12"
	  }, [_c('div', {
	    staticClass: "masthead-logo-mobile mobile"
	  }, [_c('img', {
	    attrs: {
	      "src": 'static/img/common/logo.png'
	    }
	  })])])])])]), _vm._v(" "), _c('mast-head', {
	    attrs: {
	      "page": "home"
	    }
	  }), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row intro-box"
	  }, [_c('div', {
	    staticClass: "col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center"
	  }, [_c('h3', {
	    staticClass: "h3-subtitle",
	    domProps: {
	      "innerHTML": _vm._s(_vm.home.subtitle)
	    }
	  })])])])]), _vm._v(" "), _c('section', [_c('my-carousel', {
	    attrs: {
	      "array": 'home_array'
	    }
	  })], 1), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center"
	  }, [_c('h2', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.home.about)
	    }
	  }), _vm._v(" "), _vm._l((_vm.home.about_body), function(p, index) {
	    return _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row text-center"
	  }, [_c('router-link', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": "/about"
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.home.link_button
	    }
	  })], 1)], 1)], 2)])])]), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "col-lg-4 col-md-4 col-sm-4 col-md-offset-1 paragraph-left"
	  }, [_c('h2', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.home.food)
	    }
	  }), _vm._v(" "), _vm._l((_vm.home.food_body), function(p, index) {
	    return _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": "/food"
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.home.link_button
	    }
	  })], 1)], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6 col-md-6 col-sm-8 box-shadow-container"
	  }, [_c('image-loader', {
	    staticClass: "image-loader-container",
	    attrs: {
	      "imgSrc": 'home/' + _vm.home.food_image
	    }
	  })], 1)])])]), _vm._v(" "), _c('section', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row text-center"
	  }, [_c('div', {
	    staticClass: "col-lg-4 col-md-4 col-sm-4 col-md-offset-1 paragraph-left mobile"
	  }, [_c('h2', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.home.projects)
	    }
	  }), _vm._v(" "), _vm._l((_vm.home.projects_body), function(p, index) {
	    return _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": "/projects"
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.home.link_button
	    }
	  })], 1)], 2), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-6 col-md-6 col-sm-8 col-md-offset-1 box-shadow-container"
	  }, [_c('image-loader', {
	    staticClass: "image-loader-container",
	    attrs: {
	      "imgSrc": 'home/' + _vm.home.projects_image
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-4 col-md-4 col-sm-4 paragraph-right desktop"
	  }, [_c('h2', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.home.projects)
	    }
	  }), _vm._v(" "), _vm._l((_vm.home.projects_body), function(p, index) {
	    return _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(p)
	      }
	    })
	  }), _vm._v(" "), _c('router-link', {
	    staticClass: "router-link-container",
	    attrs: {
	      "to": "/projects"
	    }
	  }, [_c('link-button', {
	    attrs: {
	      "label": _vm.home.link_button
	    }
	  })], 1)], 2)])])]), _vm._v(" "), _c('section', {
	    staticClass: "pure-text-centered",
	    attrs: {
	      "id": "clients"
	    }
	  }, [_c('client-section')], 1), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-bottom"
	  }, [_c('text-ticker', {
	    attrs: {
	      "page": "home"
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "section-joined-top"
	  }, [_c('footer-image')], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('nav', [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row nav-top-row"
	  }, [_c('div', {
	    class: {
	      'active': _vm.panelOpen
	    },
	    attrs: {
	      "id": "nav-burger"
	    },
	    on: {
	      "click": _vm.clickBurger
	    }
	  }, [_c('div', {
	    staticClass: "burger-bar burger-bar-2"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "burger-bar burger-bar-1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "burger-bar burger-bar-3"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "top-bar"
	  }, [_c('div', {
	    staticClass: "nav-logo"
	  }, [(_vm.pagename !== 'home') ? _c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('img', {
	    staticClass: "nav-logo-png",
	    attrs: {
	      "src": 'static/img/common/logo.png'
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.pagename == 'home') ? _c('div', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#top'),
	      expression: "'#top'"
	    }]
	  }, [_c('img', {
	    staticClass: "nav-logo-png nav-logo-home",
	    class: {
	      'active': _vm.hideMainMenu
	    },
	    attrs: {
	      "src": 'static/img/common/logo.png'
	    }
	  })]) : _vm._e()], 1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/about"
	    }
	  }, [_c('span', {
	    class: {
	      'active': _vm.pagename === 'about'
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.about)
	    }
	  })])], 1), _vm._v(" "), _c('li', {
	    staticClass: "top-bar-dropdown-container",
	    on: {
	      "mouseover": function($event) {
	        _vm.showDropdown = true
	      },
	      "mouseout": function($event) {
	        _vm.showDropdown = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "top-bar-dropdown-button"
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.whatwedo)
	    }
	  })]), _vm._v(" "), (_vm.showDropdown) ? _c('div', {
	    staticClass: "top-bar-dropdown-links"
	  }, [_c('div', {
	    staticClass: "top-bar-dropdown-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/food"
	    }
	  }, [_c('span', {
	    class: {
	      'active': _vm.pagename === 'food'
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.food)
	    }
	  })])], 1), _vm._v(" "), _c('div', {
	    staticClass: "top-bar-dropdown-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/projects"
	    }
	  }, [_c('span', {
	    class: {
	      'active': _vm.pagename === 'projects'
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.projects)
	    }
	  })])], 1)]) : _vm._e()]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#gallery-container'),
	      expression: "'#gallery-container'"
	    }]
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.gallery)
	    }
	  })]), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#contact-section'),
	      expression: "'#contact-section'"
	    }]
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.contact)
	    }
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "nav-panel",
	    class: {
	      'active': _vm.panelOpen
	    }
	  }, [_c('div', {
	    staticClass: "nav-panel-inner",
	    class: {
	      'active': _vm.panelOpen
	    }
	  }, [_c('ul', [(_vm.pagename === 'home') ? _c('li', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#top'),
	      expression: "'#top'"
	    }]
	  }, [_c('span', {
	    class: {
	      'active': _vm.pagename === 'home'
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.home)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.pagename !== 'home') ? _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('span', {
	    class: {
	      'active': _vm.pagename === 'home'
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.home)
	    }
	  })])], 1) : _vm._e(), _c('br'), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/about"
	    }
	  }, [_c('span', {
	    class: {
	      'active': _vm.pagename === 'about'
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.about)
	    }
	  })])], 1), _c('br'), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/food"
	    }
	  }, [_c('span', {
	    class: {
	      'active': _vm.pagename === 'food'
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.food)
	    }
	  })])], 1), _c('br'), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/projects"
	    }
	  }, [_c('span', {
	    class: {
	      'active': _vm.pagename === 'projects'
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.projects)
	    }
	  })])], 1), _c('br'), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#gallery'),
	      expression: "'#gallery'"
	    }],
	    on: {
	      "click": _vm.clickNavPanel
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.gallery)
	    }
	  })]), _c('br'), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "scroll-to",
	      rawName: "v-scroll-to",
	      value: ('#contact-section'),
	      expression: "'#contact-section'"
	    }],
	    on: {
	      "click": _vm.clickNavPanel
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.nav.contact)
	    }
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "header-arrow",
	    class: {
	      'active': !_vm.hideArrow && _vm.pagename !== 'about'
	    }
	  }, [_c('img', {
	    staticClass: "social-icon",
	    attrs: {
	      "src": 'static/img/common/left_dark.svg'
	    }
	  })])])
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.fd6ee7922a69d1e98b16.js